import React, { useEffect, useState } from 'react';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import { CardLoanTasksProps } from 'components/Atoms/Cards/CardLoanTasks/CardLoanTasks';
import { Tooltip } from 'react-tooltip'
import ConstructionBudget from './ConstructionBudget';
import { formatterCurrency } from '@common/utils/formatters/formatter';
import { ModuleKeys } from 'services/task/modules-keys.constanst';

interface Props {
  tasks?: Task[] | any[],
}

const useCardConstruction = ({ tasks }: Props) => {
  const [dataTask, setDataTask] = useState<Task>();
  const [stepNow, setStepNow] = useState<TaskResponse>();
  const [response, setResponse] = useState<TaskResponse>();

  useEffect(() => {
    if (tasks) {
      const data: Task = tasks.find((item) => item.key === ModuleKeys.CONSTRUCTION);
      setDataTask(data);
      setResponse(data?.responses.find(item => item.step === 1));

      if (data?.responses.length > 0)
        setStepNow(data?.responses.reduce((max, obj) => obj.step > max.step ? obj : max, data?.responses[0]));
    }
  }, [tasks]);

  const generateCirclesFooter: any = () => {
    const addAnotherDocs = dataTask?.responses?.filter(item => item.key === 'doc-another');
    const docsStates = addAnotherDocs?.map(item => item.state) || []; 
    return [response?.state, ...docsStates];
  };

  const getTotalApproved = () =>
    dataTask?.responses?.filter((item: any) => item.state !== TaskState.Draft)?.length;

  const tooltipsTexts: any = {
    "APPROVED": 'Approved',
    "REVIEW": 'In Review',
    "REQUEST_ERROR": 'Rejected',
    "DRAFT": 'Not submmitted',
  }

  const tooltipTexts = (state: string) => tooltipsTexts[state];

  const card: CardLoanTasksProps =
  {
    key: ModuleKeys.CONSTRUCTION,
    title: <h4 className="h4">Construction Budget</h4>,
    type: 'Major task',
    steps: 1,
    stepCurrent: stepNow?.step || 0,
    state: dataTask?.state,
    actions: dataTask ? [<ConstructionBudget key={1} task={dataTask} />] : [],
    text: (
      <p className="body-card">
        My estimated construction budget is{' '}
        <span className="body-card-bold-line">
          {response?.metadata?.budgetValue ?
            formatterCurrency(response?.metadata?.budgetValue) :
            'unknown'
          }
        </span>
      </p>
    ),
    text2: (
      <div className='docs-section'>
        <div className='labels'>
          <p className={`body-regular body-regular-bold`}>
            Document status
          </p>
          <p className={`body-card`}>
            {getTotalApproved()}/1 submitted
          </p>
        </div>
        <div className={`circles-tags`}>
          {generateCirclesFooter()?.map((state: string, index: number) => {
            let _state = state?.toUpperCase() || 'DRAFT';

            return (
              <div key={index}>
                <div
                  data-tooltip-id={`circle-state-${_state}`}
                  data-tooltip-html={`<b>${tooltipTexts(_state)}</b><br/><span>Itemized construction Budget/SoW</span>`}
                  className={`circle circle-${_state}`}
                />
                <Tooltip
                  id={`circle-state-${_state}`}
                  className={`circle-state-tooltip circle-state-tooltip-${_state}`}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  };

  if (!dataTask)
    return { card: null };

  return {
    card,
    dataTask
  };
};

export default useCardConstruction;